
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.714 6.571l-2.643 2.5c-.285.286-.785.286-1-.071a.69.69 0 010-1l3.072-2.857c.214-.214.571-.214.857-.072l4.429 2.572 4.5-4.572a.69.69 0 011 0 .69.69 0 010 1l-4.929 5a.648.648 0 01-.5.215c-.071 0-.214 0-.357-.143L6.714 6.57z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.714 0h18.572c.428 0 .714.286.714.714v11.429c0 .428-.286.714-.714.714h-5.357l3 6.143c.214.357.071.786-.286.929-.072.071-.214.071-.286.071-.286 0-.5-.143-.643-.429l-3.357-6.714H7.572l-3.358 6.714c-.143.286-.357.429-.643.429-.084 0-.144 0-.208-.015a.664.664 0 01-.149-.056c-.285-.143-.428-.572-.285-.929l3.07-6.143H.715c-.428 0-.714-.286-.714-.714V.714C0 .286.286 0 .714 0zm.715 11.429H18.57v-10H1.43v10z","fill":"currentColor"}})])
          )
        }
      }
    